const UPDATE_ROUGE_EXCLUSIVE_REWARDS = 'UPDATE_ROUGE_EXCLUSIVE_REWARDS';
const SHOW_ROUGE_REWARD_LEARN_MORE_MODAL = 'SHOW_ROUGE_REWARD_LEARN_MORE_MODAL';
const HIDE_ROUGE_REWARD_LEARN_MORE_MODAL = 'HIDE_ROUGE_REWARD_LEARN_MORE_MODAL';

export {
    UPDATE_ROUGE_EXCLUSIVE_REWARDS,
    SHOW_ROUGE_REWARD_LEARN_MORE_MODAL,
    HIDE_ROUGE_REWARD_LEARN_MORE_MODAL
};
